import { useMemo } from "react";
import { calDnmUvmRatio } from "@/lib/stake/stake-constants";

/**
 * Pure memoized wrapper around calDnmUvmRatio.
 * Stable reference when dnmWei is the same — safe for render equality checks.
 */
export function useDnmUvmRatio(dnmWei: bigint): bigint {
  return useMemo(() => calDnmUvmRatio(dnmWei), [dnmWei]);
}
